// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CorrectiveMaintenanceReminderDto,
  CountWidgetDto,
} from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class CorrectiveMaintenanceReminderApiClient extends BaseCRUDApiClient<CorrectiveMaintenanceReminderDto> {
  baseUrl = this.config.apiEndpoint + '/corrective-maintenance-reminder';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
  getCountInPeriod(
    fromDate: string | undefined,
    toDate: string | undefined,
    filters: any,
  ) {
    return this.http.post<CountWidgetDto>(
      `${this.baseUrl}/get-count-in-period`,
      {
        fromDate,
        toDate,
        ...filters,
      },
    );
  }
}
